<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Editar Participante</h2>
            </div>
            <form-novo-participante></form-novo-participante>
        </div>
    </div>
</template>

<script>
import FormNovoParticipante from "./form-novo-participante";

export default {
    name: "editar-evento",
    components: {
        FormNovoParticipante,
    },
    data() {
        return {}
    },
}
</script>

